/**
 * Cleo ERP SaaS — Route protégée
 * Redirige vers /login si non authentifié.
 * Filtre par type d'utilisateur (client ou admin).
 */
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

function ProtectedRoute({ children, requiredType }) {
  const { isAuthenticated, user } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (requiredType && user?.user_type !== requiredType) {
    // Admin qui tente d'accéder au dashboard client → redirect admin
    if (user?.user_type === 'ADMIN') {
      return <Navigate to="/admin/tenants" replace />;
    }
    // Client qui tente d'accéder à l'admin → redirect client
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}

export default ProtectedRoute;
